import { IconDownload } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { PDFDownloadLink, StyleSheet } from '@react-pdf/renderer';
import { useFlexiLoanFeaturesTablePDF } from '../FlexiLoanFeatures/FlexiLoanFeatures.helpers';
import styles from './ExportToPDFButton.module.css';
import { ProductsPagePDF } from './ProductsPagePDF/ProductsPagePDF';

type TPDFDownloadParams = {
  loading: boolean;
  error: Error;
};

export const ExportToPDFButton = () => {
  const flexiLoanTableData = useFlexiLoanFeaturesTablePDF();

  /**
   * Bugfix for unit tests - React-pdf is mocked to return null in Jest, so to make sure the tests don't break,
   * this component shouldn't be rendered when the module is null.
   */
  if (!StyleSheet) {
    return null;
  }

  return (
    <PDFDownloadLink
      document={<ProductsPagePDF flexiLoanTableData={flexiLoanTableData} />}
      fileName="iwoca-products.pdf"
    >
      {/* @ts-ignore */}
      {({ loading, error }: TPDFDownloadParams) =>
        error ? null : (
          <Button
            variant="secondary-alt"
            className={styles.button}
            loading={loading}
          >
            <IconDownload />
            Export as PDF
          </Button>
        )
      }
    </PDFDownloadLink>
  );
};
